// Fecha de HOY en la hora de la computadora, como "YYYY-MM-DD".
// No usar new Date().toISOString(): eso es hora UTC y despues de las 6 pm en
// Mexico ya da la fecha de manana.
const dosDigitos = (n) => String(n).padStart(2, "0");
const formato = (d) => `${d.getFullYear()}-${dosDigitos(d.getMonth() + 1)}-${dosDigitos(d.getDate())}`;

export const hoyLocal = () => formato(new Date());

export const enDiasLocal = (dias) => {
  const d = new Date();
  d.setDate(d.getDate() + dias);
  return formato(d);
};

export default hoyLocal;
